import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import texture from '../../assets/cards/texture.png';

const MyDigitalCardGeneral = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const userId = authState.user._id;
  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    think5whysCode:authState.user.think5whyscode,
    image: '',
  });

  const [originalProfileData, setOriginalProfileData] = useState({}); 
  const [profileExists, setProfileExists] = useState(false);
  
  const [profileId, setProfileId] = useState('');

  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false); 
  const [updateSuccess, setUpdateSuccess] = useState(false); 

  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState(''); 
 
  const [creatingProfile, setCreatingProfile] = useState(false); 
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    try {
      const config = {
        url: "/myprofile/byid",
        method: 'post',
        data: {userId: userId},
        headers: { Authorization: authState.token },
      };
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            setProfileExists(true);
            const { profile } = response;
            setProfileId(profile._id);
            setProfileData({
              userId: profile.userId,
              name: profile.name,
              gender: profile.gender,
              dob: profile.dob,
              email: profile.email,
              mobile: profile.mobile,
              city: profile.city,
              institution: profile.institution,
              socialLinks: profile.socialLinks,
              personalPageLink: profile.personalPageLink,
              think5whysCode: profile.think5whysCode,
            });
          } else {
            console.error("Failed to get profile:", response);
            setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
          }
        })
        .catch(error => {
          console.error("Error getting profile:", error);
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        });
    } catch (error) {
      console.error('Error in getting:', error);
      setCreateSuccessMsg("Sorry! Profile not found. Please retry.");
    }
  }, [userId, fetchData, setProfileId]);

  
  return (
    <div className='flex justify-center'>
    <div 
      style={{
        border: '4px solid purple',
        borderRadius: '10px',
        width: '300px',
        height: '533px',
        padding: '20px',
        fontFamily: 'Arial',
        textAlign: 'center',
        backgroundImage: `url(${texture})`, // Background texture image
        backgroundSize: 'cover', // Adjust size to cover the container
        backgroundRepeat: 'no-repeat',
        color: 'blue',
      }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
      <img 
        src={
          `/api/downloads/users/profilepic/${profileData.think5whysCode}.png` || 
          `/api/downloads/users/profilepic/noprofilepic.png`
        }
        alt="Profile Pic" 
        className="w-32 h-32 rounded-full border-4 border-yellow-400" 
      />
      </div>
      <h2 className='text-black mt-4 mb-4 font-bold text-xl'>{profileData.name}</h2>
      <p className='text-black text-sm'>ID#: {profileData.think5whysCode}</p>
      <p className='text-black text-sm'>Institution: {profileData.institution}</p>
      <p className='text-black text-sm'>Email: {profileData.email}</p>
      <p className='text-black text-sm'>Mobile: {profileData.mobile}</p>
      <p className='text-black text-sm'>Place: {profileData.city}</p>
      <div className='flex flex-row justify-center text-purple-600 mt-8 mb-8'>
        <a href={profileData.socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="mx-2">
          <FontAwesomeIcon className='text-red-500' icon={faFacebook} size="x" />
        </a>
        <a href={profileData.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="mx-2">
          <FontAwesomeIcon className='text-red-500' icon={faInstagram} size="x" />
        </a>
        <a href={profileData.socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="mx-2">
          <FontAwesomeIcon className='text-red-500' icon={faTwitter} size="x" />
        </a>
        <a href={profileData.personalPageLink} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon className='text-red-500' icon={faLinkedin} size="x" />
        </a>
      </div>
      <p className="w-full h-10 bg-yellow-100 text-blue-700 mt-2 mr-2 text-sm flex items-center justify-center">
        Powered by 
        <img 
          src={logo} 
          alt="Think5Whys" 
          style={{ 
            width: '25px', 
            height: '25px', 
            padding: '5px',
            marginLeft: '5px',
            marginRight: '5px'
          }} 
        /> 
        think5whys.com
      </p>
    </div>
  </div>
  );
};

export default MyDigitalCardGeneral;
